module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am49-2e1c2b0edb894c4359140a6b94a309f8.jpg";